module.exports = __webpack_public_path__ + "static/media/co.d1a61f94.svg";